export default function TrustSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '安全可信赖',
      desc: '华体会官网采用银行级SSL加密技术，持有正规运营牌照，全方位保障用户信息安全与资金安全。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '7×24小时客服',
      desc: '专业客服团队全天候在线，快速响应您的每一个需求，让您畅享无忧的体育竞猜体验。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速充值提现',
      desc: '支持多种支付方式，充值秒到账，提现快速处理，让您的资金流转畅通无阻。',
    },
    {
      icon: 'ri-gift-line',
      title: '丰厚会员福利',
      desc: '注册即享新人礼包，每日签到、周周返水、节日专属活动，让每一次投注都物超所值。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端畅玩',
      desc: '华体会官网支持PC、手机、平板多端访问，随时随地畅享精彩赛事与竞猜乐趣。',
    },
    {
      icon: 'ri-verified-badge-line',
      title: '公平公正',
      desc: '华体会官网采用国际认证的随机算法，确保每一场竞猜公平公正，让您放心投注。',
    },
  ];

  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择华体会官网
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-xl mx-auto">
            华体会官网用心打造安全、公平、便捷的体育竞猜平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex gap-4 bg-background-50 rounded-lg p-5 border border-background-200/60"
            >
              <div className="w-10 h-10 flex items-center justify-center shrink-0 bg-accent-100 rounded-lg">
                <i className={`${feature.icon} text-accent-700 text-lg`}></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5">
                  {feature.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}